const commonUtility = require('./commonUtility');
const stringUtil = require('../string/stringUtil');

module.exports.getPrintingTemplate = function (printingTemplateType, constraints)
{
    if (constraints == null) constraints = {};

    const templates = commonUtility.getPrintingTemplates().filter(template => template.type === printingTemplateType);

    if (templates.length === 0) return null;

    var matchedTemplateWeight = -1;
    var matchedTemplateIndex = -1;

    for (let index = 0; index < templates.length; index++) 
    {
        let currentWeight = 0;
        const template = templates[index];

        if (template.isDisabled)
            continue;

        //No constraints
        if (stringUtil.isStringNullOrEmpty(template.json))
        {
            if (currentWeight > matchedTemplateWeight)
            {
                matchedTemplateWeight = currentWeight;
                matchedTemplateIndex = index;
            }

            continue;
        }

        const document = JSON.parse(template.json);
        const templateConstraints = document.constraints;

        if (templateConstraints.storefronts && templateConstraints.storefronts.length > 0)
        {
            if (!templateConstraints.storefronts.some(x => stringUtil.areStringSame(x, `${constraints.propertyId}::${constraints.storefrontId}`)))
                continue;

            currentWeight = currentWeight + 1;
        }

        if (templateConstraints.dispatchTypes && templateConstraints.dispatchTypes.length > 0)
        {
            if (!templateConstraints.dispatchTypes.some(x => stringUtil.areStringSame(x, constraints.dispatchType)))
                continue;

            currentWeight = currentWeight + 1;
        }

        if (templateConstraints.venueCodes && templateConstraints.venueCodes.length > 0)
        {
            if (!templateConstraints.venueCodes.some(x => stringUtil.areStringSame(x, constraints.venue)))
                continue;

            currentWeight = currentWeight + 1;
        }

        if (stringUtil.areStringSame(constraints.subType, "sale.receipt.print")
            && templateConstraints.paidUnpaids && templateConstraints.paidUnpaids.length > 0)
        {
            if (constraints.isPaid && !templateConstraints.paidUnpaids.some(x => stringUtil.areStringSame(x, "Paid")))
                continue;

            if (!constraints.isPaid && !templateConstraints.paidUnpaids.some(x => stringUtil.areStringSame(x, "UnPaid")))
                continue;

            currentWeight = currentWeight + 5;
        }

        if (currentWeight > matchedTemplateWeight)
        {
            matchedTemplateWeight = currentWeight;
            matchedTemplateIndex = index;
        }
    }

    if (matchedTemplateIndex >= 0)
        return templates[matchedTemplateIndex];

    return null;
}